/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from "react";

// internal components
import { ResetPassword } from "./reset-password";
import { GeneratePassword } from "./generate-password";


const CustomerPassword = ({ customer }) => {
    const [activeView, setActiveView] = useState(0);

    const Component = () => {
        if (activeView === 0) {
            return <ResetPassword customer={customer} />
        }

        return <GeneratePassword customer={customer} />
    }

    return (
        <>
            <nav className="breadcrumb is-pulled-right" aria-label="breadcrumbs">
                {['Send Reset Link', 'Generate a Password'].map((o, index) => (
                    <p key={o} className={activeView === index ? 'is-hidden' : 'is-size-4'}>
                        <a onClick={() => setActiveView(index)}>
                            <span className="icon-text">
                                <span>{o}</span>
                                <span className="icon">
                                    <i className="fas fa-arrow-right"></i>
                                </span>
                            </span>
                        </a>
                    </p>
                ))}
            </nav>

            <Component />
        </>
    );
}

export { CustomerPassword };
